import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const appUsageData = [
    {
        name: 'Google Drive',
        hours: 48,
        icon: './assets/images/app-activity/chart-icons/drive.svg',
    },
    {
        name: 'Google Chrome',
        hours: 50,
        icon: './assets/images/app-activity/chart-icons/chrome.svg',
    },
    {
        name: 'Microsoft Excel',
        hours: 55,
        icon: './assets/images/app-activity/chart-icons/excel.svg',
    },
    {
        name: 'Figma',
        hours: 32,
        icon: './assets/images/app-activity/chart-icons/figma.svg',
    },
    {
        name: 'Illustrator',
        hours: 44,
        icon: './assets/images/app-activity/chart-icons/illustrator.svg',
    },
    {
        name: 'Gmail',
        hours: 30,
        icon: './assets/images/app-activity/chart-icons/gmail.svg',
    },
    {
        name: 'Photoshop',
        hours: 33,
        icon: './assets/images/app-activity/chart-icons/photoshop.svg',
    },
    {
        name: 'Edge',
        hours: 35,
        icon: './assets/images/app-activity/chart-icons/edge.svg',
    },
    {
        name: 'SyncUp',
        hours: 42,
        icon: './assets/images/app-activity/chart-icons/syncup.svg',
    },
    {
        name: 'Premiere Pro',
        hours: 58,
        icon: './assets/images/app-activity/chart-icons/premiere.svg',
    },
    {
        name: 'Slack',
        hours: 40,
        icon: './assets/images/app-activity/chart-icons/slack.svg',
    },
    {
        name: 'HubStaff',
        hours: 34,
        icon: './assets/images/app-activity/chart-icons/hubstaff.svg',
    },
    {
        name: 'D5 Render',
        hours: 53,
        icon: './assets/images/app-activity/chart-icons/d5render.svg',
    },
    {
        name: 'Skype',
        hours: 41,
        icon: './assets/images/app-activity/chart-icons/skype.svg',
    },
    {
        name: 'OS',
        hours: 20,
        icon: './assets/images/app-activity/chart-icons/windows.svg',
    },
    {
        name: 'TimeTracker',
        hours: 57,
        icon: './assets/images/app-activity/chart-icons/timetracker.svg',
    },
    {
        name: 'Word',
        hours: 45,
        icon: './assets/images/app-activity/chart-icons/word.svg',
    },
];

const AppUsageBarChart = () => {
    const options = {
        chart: {
            type: 'column',
            height: 500,
            spacingBottom: 60,
        },
        credits: {
            enabled: false,
        },
        title: {
            text: null,
        },
        xAxis: {
            categories: appUsageData.map((item) => item.name),
            labels: {
                style: {
                    fontSize: '12px',
                    fontFamily: 'Manrope',
                },
            },
        },
        yAxis: {
            min: 0,
            title: { text: null },
            gridLineWidth: 0,
        },
        legend: { enabled: false },
        tooltip: {
            useHTML: true,
            backgroundColor: '#2C2C2C',
            borderColor: '#2C2C2C',
            borderRadius: 6,
            style: {
                fontFamily: 'Manrope',
                fontSize: '13px',
                color: '#FFFFFF',
                textAlign: 'center',
            },
            formatter: function () {
                // Convert decimal hours to HH:MM:SS
                const totalSeconds = Math.floor(this.point.y * 3600);
                const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
                const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
                const seconds = String(totalSeconds % 60).padStart(2, '0');

                return `
            <div style="padding: 4px 8px;">
                <div style="font-weight: 500;">${this.point.name}</div>
                <div style="font-size: 12px;">Time Spent &nbsp; ${hours}:${minutes}:${seconds}</div>
            </div>
        `;
            }
        }
        ,
        plotOptions: {
            column: {
                color: '#FF832A',
                borderRadius: 0,
                groupPadding: 0.1,
                pointPadding: 0.05,
                pointWidth: 28,
            },
            series: {
                dataLabels: {
                    enabled: true,
                    useHTML: true,
                    formatter: function () {
                        const icon = this.point.custom?.icon;
                        return icon
                            ? `<div style="margin-bottom: -30px; display: flex; justify-content: center; width: 42px; height: 42px;">
                                <img src="${icon}" alt="icon"
                                  style="width: 42px; height: 42px; border-radius: 50%;" />
                              </div>`
                            : '';
                    },
                },
            },
        },
        series: [
            // {
            //     name: 'Hours',
            //     data: appUsageData.map((item) => ({
            //         y: item.hours,
            //         custom: {
            //             icon: item.icon,
            //         },
            //     })),
            // },
            {
                name: 'Hours',
                data: appUsageData.map((item) => ({
                    name: item.name,
                    y: item.hours,
                    custom: {
                        icon: item.icon,
                    },
                })),
            },
        ],
    };

    return (
        <div style={{ position: 'relative' }}>
            <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
    );
};

export default AppUsageBarChart;
